var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.25C4.27209 2.25 1.25 5.27209 1.25 9C1.25 12.7279 4.27209 15.75 8 15.75C11.7279 15.75 14.75 12.7279 14.75 9C14.75 5.27209 11.7279 2.25 8 2.25ZM10.2825 10.2391C10.5706 10.5272 10.5706 10.9944 10.2825 11.2825C10.1384 11.4266 9.94962 11.4986 9.76079 11.4986C9.57197 11.4986 9.38315 11.4266 9.23909 11.2825L8 10.0434L6.76094 11.2825C6.61688 11.4266 6.42806 11.4986 6.23924 11.4986C6.05041 11.4986 5.86159 11.4266 5.71753 11.2825C5.42938 10.9944 5.42938 10.5272 5.71753 10.2391L6.95662 9L5.71753 7.76091C5.42938 7.47276 5.42938 7.00562 5.71753 6.71747C6.00568 6.42932 6.47282 6.42932 6.76097 6.71747L8.00003 7.95656L9.23909 6.71747C9.52724 6.42932 9.99438 6.42932 10.2825 6.71747C10.5707 7.00559 10.5707 7.47276 10.2825 7.76091L9.04341 9L10.2825 10.2391Z",
    fill: "#7257F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.84a7592a8594cd0a6f3789ed43b8186a.svg";
export { ForwardRef as ReactComponent };